import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOHead from '@/components/feature/SEOHead';
import { aboutInfo, reviews } from '@/mocks/manga';

export default function AboutPage() {
  const pageTitle = '关于我们-蜜桃少年漫画-漫画全集下拉式免费阅读-土豪漫画网';
  const pageDesc = '土豪漫画网关于我们页面，介绍蜜桃少年漫画的品牌故事、发展历程、核心优势和联系方式。土豪漫画网是国内领先的在线漫画阅读平台，提供漫画全集下拉式免费阅读服务。';
  const pageKeywords = '关于我们,蜜桃少年漫画,漫画全集下拉式免费阅读,土豪漫画网';

  const breadcrumbItems = [
    { label: '首页', path: '/' },
    { label: '关于我们' },
  ];

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "土豪漫画网",
    "url": "http://i2p1d.com/",
    "description": "国内领先的在线漫画阅读平台，提供漫画全集下拉式免费阅读服务",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "望京SOHO T2 12层",
      "addressLocality": "北京市",
      "addressRegion": "朝阳区",
      "addressCountry": "CN"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "400-888-6666",
      "contactType": "customer service",
      "email": "hello@i2p1d.com"
    }
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "首页", "item": "http://i2p1d.com/" },
      { "@type": "ListItem", "position": 2, "name": "关于我们" },
    ]
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "土豪漫画网是什么？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "土豪漫画网是国内领先的在线漫画阅读平台，提供漫画全集下拉式免费阅读服务。用户可以通过下拉式阅读方式，在电脑和手机上流畅浏览数千部中文漫画作品。"
        }
      },
      {
        "@type": "Question",
        "name": "如何在土豪漫画网免费阅读蜜桃少年漫画？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "打开土豪漫画网首页，在搜索栏输入'蜜桃少年'或直接浏览漫画列表找到该作品。点击漫画封面进入详情页，选择任意章节即可开始下拉式免费阅读，无需注册或付费。"
        }
      },
      {
        "@type": "Question",
        "name": "土豪漫画网的漫画需要付费吗？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "不需要！土豪漫画网所有漫画作品均为免费阅读，无需任何付费订阅或购买。我们致力于为漫画爱好者提供完全免费的优质阅读体验。"
        }
      },
      {
        "@type": "Question",
        "name": "什么是下拉式阅读？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "下拉式阅读是土豪漫画网创新的在线阅读方式。用户只需向下滚动页面即可连续浏览漫画的所有页面，无需频繁点击翻页按钮，让阅读体验更加流畅自然。"
        }
      },
    ]
  };

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": pageTitle,
    "description": pageDesc,
    "url": "http://i2p1d.com/about",
    "isPartOf": { "@type": "WebSite", "name": "土豪漫画网", "url": "http://i2p1d.com/" },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "首页", "item": "http://i2p1d.com/" },
        { "@type": "ListItem", "position": 2, "name": "关于我们" },
      ]
    }
  };

  return (
    <>
      <SEOHead
        title={pageTitle}
        description={pageDesc}
        keywords={pageKeywords}
        canonicalUrl="http://i2p1d.com/about"
        ogTitle={pageTitle}
        ogDescription={pageDesc}
      />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }} />

      <Navbar />

      <main className="pt-20 pb-14">
        <div className="max-w-5xl mx-auto px-4 md:px-6">
          <Breadcrumb items={breadcrumbItems} />

          <section className="mt-8 text-center mb-16">
            <h1 className="text-3xl md:text-5xl font-heading font-black text-foreground-950 mb-4">关于我们</h1>
            <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
              {aboutInfo.introduction}
            </p>
          </section>

          <section className="mb-16">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
              {aboutInfo.stats.map((stat) => (
                <div key={stat.label} className="bg-background-50 rounded-2xl p-6 text-center">
                  <p className="text-3xl md:text-4xl font-heading font-black text-primary-500 mb-2">{stat.value}</p>
                  <p className="text-sm text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-16">
            <h2 className="text-2xl font-heading font-bold text-foreground-950 mb-3 text-center">我们的使命</h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto text-center leading-relaxed mb-10">
              {aboutInfo.mission}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
              {aboutInfo.features.map((feat) => (
                <div key={feat.title} className="bg-background-50 rounded-2xl p-6 flex gap-4">
                  <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-xl bg-primary-100">
                    <i className={`${feat.icon} text-xl text-primary-600 w-5 h-5 flex items-center justify-center`}></i>
                  </div>
                  <div>
                    <h3 className="text-base font-bold text-foreground-900 mb-1">{feat.title}</h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">{feat.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-16">
            <h2 className="text-2xl font-heading font-bold text-foreground-950 mb-8 text-center">读者口碑</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
              {reviews.map((review) => (
                <div key={review.id} className="bg-background-50 rounded-2xl p-5 md:p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                      <img src={review.avatar} alt={review.userName} className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">{review.userName}</p>
                      <div className="flex items-center gap-0.5">
                        {Array.from({ length: review.rating }).map((_, i) => (
                          <i key={i} className="ri-star-fill text-primary-500 text-xs"></i>
                        ))}
                      </div>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{review.content}</p>
                  <p className="text-xs text-foreground-400 mt-2">{review.date}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-16">
            <h2 className="text-2xl font-heading font-bold text-foreground-950 mb-8 text-center">常见问题</h2>
            <div className="max-w-2xl mx-auto space-y-3">
              {faqSchema.mainEntity.map((faq) => (
                <details key={faq.name} className="bg-background-50 rounded-xl p-5 cursor-pointer group">
                  <summary className="text-sm font-bold text-foreground-900 list-none flex items-center justify-between">
                    {faq.name}
                    <i className="ri-add-line text-foreground-400 group-open:hidden w-5 h-5 flex items-center justify-center"></i>
                    <i className="ri-subtract-line text-foreground-400 hidden group-open:block w-5 h-5 flex items-center justify-center"></i>
                  </summary>
                  <p className="text-sm text-foreground-500 mt-3 leading-relaxed">
                    {faq.acceptedAnswer.text}
                  </p>
                </details>
              ))}
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-heading font-bold text-foreground-950 mb-8 text-center">联系我们</h2>
            <div className="max-w-lg mx-auto bg-background-50 rounded-2xl p-8">
              <div className="space-y-5">
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                    <i className="ri-mail-line text-primary-600 w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-400">电子邮箱</p>
                    <p className="text-sm text-foreground-900 font-medium">{aboutInfo.contact.email}</p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                    <i className="ri-phone-line text-primary-600 w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-400">客服电话</p>
                    <p className="text-sm text-foreground-900 font-medium">{aboutInfo.contact.phone}</p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                    <i className="ri-map-pin-line text-primary-600 w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-400">公司地址</p>
                    <p className="text-sm text-foreground-900 font-medium">{aboutInfo.contact.address}</p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                    <i className="ri-wechat-line text-primary-600 w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-400">微信公众号</p>
                    <p className="text-sm text-foreground-900 font-medium">{aboutInfo.contact.wechat}</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </>
  );
}